import React from 'react';
import { Link } from '../../../ui';
import { Divider } from './Divider';

export const Typography = () => (
	<>
		<h1 id="typography">Header 1</h1>
		<h2>Header 2</h2>
		<h3>Header 3</h3>
		<h4>Header 4</h4>
		<h5>Header 5</h5>
		<p>
			Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aliquid laborum,
			esse repellendus molestias accusantium iusto, hic neque expedita repellat,
			fuga enim. Culpa corporis, nisi placeat illo minus laborum cumque eaque?
		</p>

		<Divider />

		<h2>Header 2</h2>
		<h4>Header 4</h4>
		<p>
			Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aliquid laborum,
			esse repellendus molestias accusantium iusto, hic neque expedita repellat,
			fuga enim. Culpa corporis, nisi placeat illo minus laborum cumque eaque?
		</p>
		<p>
			Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aliquid laborum,
			esse repellendus molestias accusantium iusto, hic neque expedita repellat,
			fuga enim. Culpa corporis, nisi placeat illo minus laborum cumque eaque?
		</p>
		<p>
			Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aliquid laborum,
			esse repellendus molestias accusantium iusto, hic neque expedita repellat,
			fuga enim. Culpa corporis, nisi placeat illo minus laborum cumque eaque?
		</p>
		<ol>
			<li>Ordered list text</li>
			<li>Ordered list text</li>
			<li>Ordered list text</li>
			<li>Ordered list text</li>
			<li>Ordered list text</li>
			<li>
				Ordered list text
				<ol>
					<li>Ordered list text</li>
					<li>Ordered list text</li>
				</ol>
			</li>
		</ol>
		<ul>
			<li>Unordered list text</li>
			<li>
				Unordered list text
				<ul>
					<li>Unordered list text</li>
					<li>Unordered list text</li>
				</ul>
			</li>
		</ul>
		<p>
			<Link href="/about">Link text</Link>
		</p>
		<blockquote>
			<p>
				Block quote text, Lorem ipsum dolor sit amet, consectetur adipisicing
				elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
				Ut enim ad minim.
			</p>
		</blockquote>
	</>
);
